import React from 'react'
import {connect} from 'react-redux'
import {Dialog, Mask, Button, ButtonArea} from 'react-weui'
import qr from 'qr-encode'
import axios from 'axios'
import qs from 'qs';
import {filterHTML} from "../utils"
import {WKOwnDialog} from '../components/wk'
import EventBus from '../utils/bus'

import '../styles/FollowLiveroom.css'


class FollowLiveroom extends React.Component {
    constructor() {
        super();
        this.state = {
            initialized: false,
            subscribed_retain: false
        }
    }

    componentDidMount() {
        try {
            EventBus.on('subscribed_retainInfo', (subscribed_retainInfo) => {
                console.log(subscribed_retainInfo)
                this.setState({
                    subscribed_retain:  subscribed_retainInfo
                })
            })
        } catch (err) {
            console.log(err)
        }
    }

    componentDidUpdate() {
        let {initialized} = this.state;
        let {followLiveroom, account} = this.props;
        if (!initialized && followLiveroom.liveroom.id) {
            if (!account.subscribed && this.props.special && this.props.special === 'classroom'){
                axios.get('/api/account/is_subscribed_retain').then((res) => {
                    if (res.data.code === 0) {
                       const subscribed_retain = res.data.data.subscribed_retain
                       if (!subscribed_retain) {
                        axios.get(`/api/liveroom/${followLiveroom.liveroom.id}/get_qrcode`, {
                            params: {
                                object_id: this.props.lecture_id,
                                object_type: 'fl_lecture'
                            }
                        })
                            .then(res => {
                                if (res.data.code === 0) {
                                    this.setState({initialized: true});

                                    this.props.dispatch({
                                        type: 'SET_LIVEROOM_QRCODE',
                                        payload: res.data.data.qrcode_content
                                    });
                                }
                            })
                        }
                    }
                })
   
            }else {
                axios.get(`/api/liveroom/${followLiveroom.liveroom.id}/follow_qrcode`).then((res) => {
                    if (res.data.code === 0) {
                        this.setState({initialized: true});

                        this.props.dispatch({
                            type: 'SET_LIVEROOM_QRCODE',
                            payload: res.data.data.qrcode_content
                        });
                    }
                });
            }
        }
    }

    hide() {
        this.props.dispatch({type: 'HIDE_FOLLOW_LIVEROOM'})
    }

    followLiveroom() {
        const {followLiveroom} = this.props
        let m = {};
        if (followLiveroom && followLiveroom.from === 'cardMessage') {
            m = {
                chatid: followLiveroom.lectureId,
                fr: 'room',
            };
        }

        axios.post(`/api/liveroom/${followLiveroom.liveroom.id}/follow`, qs.stringify(m)).then((response) => {
            if (response.data.code === 0) {
                this.props.dispatch({
                    type: 'FOLLOW_LIVEROOM',
                    payload: {
                        liveroom_id: followLiveroom.liveroom.id
                    }
                })

                let pathName = window.location.pathname.trim();
                if (/lecture/.test(pathName)) {
                    if (!followLiveroom.callback){
                        this.props.dispatch({
                            type: 'LECTURE_SET_FANS'
                        })
                    }
                } else if (/channel/.test(pathName)) {
                    this.props.dispatch({
                        type: 'CHANNEL_SET_FANS'
                    })
                } else if (/liveroom/.test(pathName)){
                     this.props.dispatch({
                        type: 'LIVEROOM_SET_FANS'
                    })
                }
                this.hide()
                this.context.page.showToast('关注成功')
                followLiveroom.callback && followLiveroom.callback()
            }
        })
    }

    render() {
        const {followLiveroom, account} = this.props
        if (!followLiveroom.showFollowLiveroom)
            return null

        if (!account.subscribed && !this.state.subscribed_retain)
            return <WKOwnDialog show={true} type="ios"
                           title={'关注' + followLiveroom.liveroom.name}
                           buttons={[{
                               label: '关闭',
                               onClick: this.hide.bind(this)
                           }]}>
                {/*<p className="follow-tips">长按二维码扫码关注，接收直播间信息</p>*/}
                <p className="content__qrcode"><img src={qr(followLiveroom.liveroomQrcode)} alt=""/></p>

                <p>长按扫码关注，接收直播间信息</p>

                {/*<p className="follow-qrcode"><img
                    className="qrcode-img"
                    src={qr(followLiveroom.liveroomQrcode)}
                    alt="follow"/></p>*/}
            </WKOwnDialog>

        const {liveroom} = followLiveroom
        return (
            <WKOwnDialog show={true} buttons={[
                {
                    label: '暂不',
                    type: 'default',
                    onClick: () => this.hide()
                },
                {
                    label: '关注',
                    onClick: () => this.followLiveroom()
                }
            ]}>
                <p style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    margin: '-9px auto 15px auto',
                    border: '1px solid #f0f0f0'}}>
                    <img src={liveroom.avatar_url} alt=""/>
                </p>
                <p style={{
                    Color: '#333',
                    fontSize: '16px'
                }}>{liveroom.name}</p>

                <p style={{textAlign: 'left',overflowY: 'scroll',maxHeight: '150px'}} dangerouslySetInnerHTML={{__html: filterHTML(liveroom.description)}}></p>

            </WKOwnDialog>
        )
    }

    componentWillMount() {
        EventBus.off('subscribed_retainInfo')
    }
}


FollowLiveroom.contextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    followLiveroom: state.followLiveroom,
    account: state.account
}))(FollowLiveroom)




// WEBPACK FOOTER //
// ./src/components/FollowLiveroom.js